import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const akeyless = defineConnector({
  identifier: "akeyless",
  name: "Akeyless",
  tagLine: "Unified secrets and machine identity platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.akeyless\\.io/.*",
  auth: customAuth("akeyless"),
  steps: [
    {
      title: "Create an access key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the [Akeyless API key quickstart](https://docs.akeyless.io/docs/api-key-creation-quickstart) to create an access key and retrieve its access ID and access key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Access ID",
          required: true,
          target: { kind: "configuration", field: "accessId" },
        },
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.akeyless.io/get-account-settings",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: "{}",
    }),
  },
});
